<app-multiple-items-with-tooltip [items]="organizations"></app-multiple-items-with-tooltip>